import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Elastic, Power4, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {TeslaSymbols} from "../../../config/TeslaSymbols";
import {TeslaParsedGameData} from "../../server/data/TeslaParsedGameData";
import {Tesla} from "../../Tesla";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";

/**
 * Created by h3 on 2017-11-09.
 */


export class BonusSymbolFreespin extends ReelStopPresentationController {

    private static readonly QUICK_STOP_ANIMATION_TIME_SCALE:number = 3;

    private _mode:string;
    private _bonusSymbolTriggered:boolean;
    private _isQuickStop:boolean;
    private _isAttentionCompleted:boolean;
    private _areAllReelStopped:boolean;
    private _overlayWilds:boolean[][];

    private _wildSymbols:any[];
    private _bonusSymbolPoints:PIXI.Point;
    private _masterTimeline:TimelineLite | null;
    private _wildLandTimeline:TimelineMax;
    private _reels:string[][];
    private _symbolToWild:string;
    private _bonusSymbol:StateReelSymbol;
    private _wildsCollected:number[];
    private _isFreespin:boolean;
    private _extraFreespinReward:number;
    private _nextGameMode:string;
    private _overlayWildsBeforeSpinStop:boolean[][];
    private _dischargeWild:boolean;
    private _freespinsPlayed:number;
    private _freespinLeft:number;


    constructor(index:number) {
        super(index, "BonusSymbolFreespin");

        this._isQuickStop = false;
        this._isAttentionCompleted = false;
        this._areAllReelStopped = false;
        this._wildSymbols = [];
        this._wildLandTimeline = new TimelineMax();
    }

    protected parseFeatureGameData(data:TeslaParsedGameData):void {
        this._mode = data.mode;
        this._bonusSymbolTriggered = data.bonusSymbolTriggered;
        this._overlayWilds = data.overlayWilds!;
        this._extraFreespinReward = data.extraFreespinRewarded;
        this._reels = data.reels;
        this._symbolToWild = data.wildSymbol;
        this._wildsCollected = data.wildsCollected;
        this._isFreespin = data.mode == GameMode.FREESPIN;
        this._nextGameMode = data.nextMode;
        this._overlayWildsBeforeSpinStop = data.overlayWildsBeforeSpinStop;
        this._dischargeWild = data.dischargeWild;
        this._freespinsPlayed = data.freespinsPlayed;
        this._freespinLeft = data.freespinsLeft;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._isFreespin) {
            if(!this.playBonusSymbolBounce(data)) {

            }
        } else {
            this.dispatchCompleteEvent(data.reelId);
        }
    }

    private playBonusSymbolBounce(data:IReelStoppedData):boolean {

        if(!this._isFreespin) {
            return false;
        }

        if(data.reelId != 4) {
            return false;
        }

        if(!this._bonusSymbolTriggered) {
            return false;
        }

        for(let i:number = 0; i < 3; i++) {
            const symbol = Reels.getSymbol(4, i);

            if(symbol && symbol.symName === "B2") {
                let positions:number[] = Helper.getSymbolPositions(4, i);
                this._bonusSymbol = symbol;
                this._bonusSymbolPoints = new PIXI.Point(positions[0], positions[1]);
                this.playSound();


                break;
            }
        }


        return false;

    }


    public onReelSpinStopped(data:IReelStoppedData):void {

        const tl:TimelineLite = new TimelineLite();

        if(!this._isFreespin) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        this.replaceSymbolToWild(data.reelId);

        if(data.reelId != 4) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        Tesla.wildCollectRelease.removeAddedWildSymbols();

        if(!this._bonusSymbolTriggered) {
            tl.add(this.getWildLanding());
            tl.add(() => this.dispatchCompleteEvent(data.reelId), "+=0.5");
            return;
        }

        tl.add([
            this._bonusSymbol.changeState({
                state : TeslaGameConfig.instance.SYMBOL_STATES.win
            }),
            () => this.getLightningOnBonusSymbol()
        ]);


        tl.add(BonusSymbolFreespin.getBonusTransformationAnimation(this._bonusSymbol));
        let extraFreespinAnimation:TimelineLite = Tesla.bonusSymbolFreespinView.getExtraFreespins(this._extraFreespinReward, this._bonusSymbolPoints);

        tl.add(extraFreespinAnimation);
        tl.add([
            this.getLightningFromBonusSymbolToCollect(),
            () => SlotGame.keypad.setZeroBetSpinCounter(this._freespinLeft),
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_UPDATE_SPINS)
        ]);

        tl.add(() => this.dispatchCompleteEvent(data.reelId), "+=0.25");

    }

    private replaceSymbolToWild(reel:number) {

        if(reel < 1 || reel > 3) {
            return;

        }

        for(let i:number = 0; i < 3; i++) {
            if(this._overlayWildsBeforeSpinStop[reel][i] === true) {
                const symbol = Reels.getSymbol(reel, i);
                if(symbol && symbol.symName !== TeslaSymbols.W2) {
                    symbol.replaceWith(TeslaSymbols.W2, symbol.reelId)
                }
            }
        }

        return;

    }

    private getWildLanding():TimelineLite {
        const allReelsTl:TimelineLite = new TimelineLite();

        if(!this._isFreespin) {
            return allReelsTl;
        }

        if(this._bonusSymbolTriggered) {
            return allReelsTl;
        }

        if(this._nextGameMode === GameMode.NORMAL) {
            return allReelsTl;
        }

        for(let reel:number = 1; reel < 4; reel++) {

            let wildSymbols = [];
            let wildSymbolsPoints = [];

            for(let i:number = 0; i < 3; i++) {

                if(this._overlayWildsBeforeSpinStop[reel][i] === false) {
                    const symbol = Reels.getSymbol(reel, i);

                    if(symbol && symbol.symName === "W2") {
                        let positions:number[] = Helper.getSymbolPositions(reel, i);
                        let wildSymbol = symbol;
                        let wildSymbolPoints = new PIXI.Point(positions[0], positions[1]);

                        wildSymbols.push(wildSymbol);
                        wildSymbolsPoints.push(wildSymbolPoints);

                    }
                }
            }

            let wildIndicatorTimeline:TimelineLite = Tesla.wildCollectIndicator.getBounceAnimation(this._wildsCollected, reel);
            let releaseIndicatorTimeline:TimelineLite = Tesla.wildCollectRelease.getWildBounceAnimation(reel, wildSymbolsPoints, wildSymbols);

            allReelsTl.add([
                wildIndicatorTimeline,
                releaseIndicatorTimeline
            ]);

        }

        return allReelsTl;

    }

    private static getBonusTransformationAnimation(bonusSymbol:StateReelSymbol):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(new TweenLite(bonusSymbol.scale, 0.2, {x : 0, y : 0, ease : Power4.easeIn}));
        tl.add(() => { bonusSymbol.replaceWith(TeslaSymbols.W2, bonusSymbol.reelId, TeslaGameConfig.instance.SYMBOL_STATES.attention)});
        tl.add(new TweenLite(bonusSymbol.scale, 0.2, {x : 1, y : 1, ease : Elastic.easeOut.config(2.5, 1)}));

        return tl;

    }

    private getLightningOnBonusSymbol():void {

        const tl:TimelineLite = new TimelineLite();

        let bonusSymbolAnimations:TimelineLite = Tesla.bonusSymbolFreespinView.getLightningAnimation(this._bonusSymbolPoints);

        tl.add(bonusSymbolAnimations);


    }

    private getLightningFromBonusSymbolToCollect():TimelineLite {

        const tl:TimelineLite = new TimelineLite();

        if(this._dischargeWild) {
            return tl;
        }

        let bonusSymbolAnimations:TimelineLite = Tesla.bonusSymbolFreespinView.getLightningToCollectAnimation(this._bonusSymbolPoints, this._overlayWilds);

        tl.add(bonusSymbolAnimations);

        return tl;

    }

    protected resetFeature():void {


    }

    private playSound():void {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_BONUS_LAND));

    }


}